import React from 'react';
import { Users, Zap, Award, Home, Globe, Shield } from 'lucide-react';
import { Card } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const iconMap = {
  Users: Users,
  Zap: Zap,
  Award: Award,
  Home: Home,
  Globe: Globe,
  Shield: Shield
};

const ProgramFeatures = ({ features }) => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);
  
  // Get translated features
  const translatedFeatures = t('clinic.features') || features;

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            {t('clinic.programAtGlance') || 'Program at a Glance'}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('clinic.programAtGlanceDesc') || 'Everything you need for an unforgettable football and learning experience'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {translatedFeatures.map((feature, index) => {
            const Icon = iconMap[features[index]?.icon] || Users;
            return (
              <Card 
                key={index}
                className="p-6 bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-t-4 border-green-600"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center">
                      <Icon className="h-7 w-7 text-green-600" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-bold text-green-600 uppercase tracking-wider mb-1">
                      {feature.category}
                    </p>
                    <h3 className="text-lg font-black text-gray-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramFeatures;